module.exports = __webpack_public_path__ + "static/media/orchidsLogo.cc3e33ad.png";